<template>
  <div class="vue-survey-builder-content vsb-content">
    <b-form-select
        v-model="selectedType"
        :options="questionTypes"
        v-on:change="questionTypeChanged(selectedType)"
    >
    </b-form-select>
    <div v-if="selectedType !== 'DEFAULT'" class="question-section">
      <div class="pb-10">
        <div class="vsb-choices-text">
          {{ $t("public.components.survey.SurveyBuilder.question") }}
        </div>
        <b-form-input
            v-model="question.body"
            type="text"
            v-bind:placeholder="
            $t(
              'public.components.survey.SurveyBuilder.placeHolder.insertQuestion'
            )
          "
        />
      </div>
      <div v-if="selectedType === 'BOOLEAN'">
        <div class="vsb-choices-text">
          {{ $t("public.components.survey.SurveyBuilder.choice") }}
        </div>

        <b-row v-for="(option, index) in question.options" :key="index">
          <b-col sm="12">
            <b-form-group>
              <b-form-radio
                  v-model="question.value"
                  :name="'defaultBoolean' + question.uuid"
                  :value="option.sequence"
                  switches
                  @change="resetDefault(option.sequence)"
              >{{ $t("public.components.survey.SurveyBuilder.default") }}
              </b-form-radio>
              <b-form-input
                  v-model="option.body"
                  class="width-100 float-left"
                  type="text"
                  v-bind:placeholder="
                  $t(
                    'public.components.survey.SurveyBuilder.placeHolder.insertOption'
                  )
                "
              />
              <button
                  v-if="index > 1"
                  class="vsb-btn-link color-red width-10 mt-10"
                  v-on:click="deleteQuestionOptionItem(question.options, index)"
              >
                {{ $t("public.components.survey.SurveyBuilder.remove") }}
              </button>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
      <div v-if="selectedType === 'DATE'"></div>
      <div v-if="selectedType === 'FILE'"></div>
      <div v-if="selectedType === 'TEXTAREA'"></div>
      <div v-if="selectedType === 'EDITOR'"></div>
      <div v-if="selectedType === 'RATING'"></div>
      <div v-if="selectedType === 'MULTI_CHOICE'">
        <div class="vsb-choices-text">
          {{ $t("public.components.survey.SurveyBuilder.choice") }}
        </div>
        <b-row v-for="(option, index) in question.options" :key="index">
          <b-col sm="12">
            <b-form-input
                v-model="option.body"
                class="width-90 float-left"
                type="text"
                v-bind:placeholder="
                $t(
                  'public.components.survey.SurveyBuilder.placeHolder.insertText'
                )
              "
            />
            <b-button
                v-if="index > 1"
                class="ml-2"
                variant="danger"
                v-on:click="deleteQuestionOptionItem(question.options, index)"
            >
              {{ $t("public.components.survey.SurveyBuilder.remove") }}
            </b-button>
          </b-col>
        </b-row>
        <div class="text-right">
          <b-button variant="primary" v-on:click="addAnotherAnswer()">
            {{ $t("public.components.survey.SurveyBuilder.anotherAnswer") }}
          </b-button>
        </div>
      </div>

      <div v-if="selectedType === 'NUMBER'">
        <label class="display-block">
          <b-row>
            <b-col cols="4">
              <b-form-checkbox
                  v-model="question.hasMinMax"
                  name="hasMinMax"
                  switches
              >{{ $t("public.components.survey.SurveyBuilder.minmax") }}
              </b-form-checkbox>
            </b-col>
            <b-col cols="4">
              <b-form-checkbox
                  v-model="question.allowDecimals"
                  name="allowDecimals"
                  switches
                  value="Single"
              >{{ $t("public.components.survey.SurveyBuilder.allowDecimal") }}
              </b-form-checkbox>
            </b-col>
          </b-row>
        </label>
        <label class="display-block">
          <span>
            <b-form-input
                v-model="question.minValue"
                :disabled="!question.hasMinMax"
                class="width-10"
                max="2048"
                min="1"
                type="number"
                v-bind:placeholder="
                $t('public.components.survey.SurveyBuilder.placeHolder.min')
              "
            />
            <span class="width-10">{{
                $t("public.components.survey.SurveyBuilder.to")
              }}</span>
            <b-form-input
                v-model="question.maxValue"
                :disabled="!question.hasMinMax"
                class="width-10"
                max="2048"
                min="1"
                type="number"
                v-bind:placeholder="
                $t('public.components.survey.SurveyBuilder.placeHolder.max')
              "
            />
          </span>
        </label>
      </div>
      <div v-if="selectedType === 'SINGLE_CHOICE'">
        <div class="vsb-choices-text">
          {{ $t("public.components.survey.SurveyBuilder.choice") }}
        </div>

        <b-row v-for="(option, index) in question.options" :key="index">
          <b-col sm="12">
            <b-form-input
                v-model="option.body"
                class="width-90 float-left"
                v-bind:placeholder="
                $t(
                  'public.components.survey.SurveyBuilder.placeHolder.insertOption'
                )
              "
            ></b-form-input>
            <b-button
                v-if="index > 1"
                class="ml-2"
                variant="danger"
                v-on:click="deleteQuestionOptionItem(question.options, index)"
            >
              {{ $t("public.components.survey.SurveyBuilder.remove") }}
            </b-button>
          </b-col>
        </b-row>
        <div class="text-right">
          <b-button variant="primary" v-on:click="addAnotherAnswer()">
            {{ $t("public.components.survey.SurveyBuilder.anotherAnswer") }}
          </b-button>
        </div>
      </div>
      <div v-if="selectedType === 'TEXT'">
        <label>
          <b-form-checkbox
              v-model="question.characterLimited"
              name="characterLimited"
              switches
          >{{ $t("public.components.survey.SurveyBuilder.characterLimit") }}
          </b-form-checkbox>
          <span>
            <b-form-input
                v-model="question.textLimit"
                :disabled="!question.characterLimited"
                class="char-limit-b-form-input"
                max="2048"
                min="1"
                placeholder=""
                type="number"
            />
          </span>
        </label>
      </div>
      <div v-if="selectedType === 'TIME'"></div>
      <div class="buttons-section text-right">
        <b-button variant="success" @click="saveQuestion(question)">
          {{ $t("public.components.survey.SurveyBuilder.save") }}
        </b-button>
        <b-button variant="danger" @click="cancelQuestion(question)">
          {{ $t("public.components.survey.SurveyBuilder.cancel") }}
        </b-button>
        <!-- <button type="button" class="vsb-btn-link mr-10 color-red" @click="deleteQuestion(question)">Delete</button> -->
      </div>
      <div v-if="selectedType === 'CORE'">
        <b-row v-for="(option, index) in question.options" :key="index">
          <b-col sm="12">
            <b-form-input
                v-model="option.body"
                class="width-90 float-left"
                v-bind:placeholder="
                $t(
                  'public.components.survey.SurveyBuilder.placeHolder.insertOption'
                )
              "
            ></b-form-input>
            <b-form-input
                v-model="option.weight"
                class="width-90 float-left"
                max="10"
                min="0"
                type="number"
                v-bind:placeholder="'Introduce el peso de la pregunta entre 0 - 10'"
            ></b-form-input>
            <b-button
                v-if="index > 1"
                class="ml-2"
                variant="danger"
                v-on:click="deleteQuestionOptionItem(question.options, index)"
            >
              {{ $t("public.components.survey.SurveyBuilder.remove") }}
            </b-button>
          </b-col>
        </b-row>
        <div class="text-right">
          <b-button variant="primary" v-on:click="addAnotherAnswer()">
            {{ $t("public.components.survey.SurveyBuilder.anotherAnswer") }}
          </b-button>
        </div>
        <b-form-group>
          <b-select
              id="weight"
              v-model="question.coreWeight"
              :options="weightCoreOptionsSelect"
              type="text"
          ></b-select>
        </b-form-group>
      </div>
    </div>
  </div>
</template>

<script>
import QuestionTypesHistoricClinicSelect from "../../json/QuestionTypesHistoricClinicSelect";
import WeightCoreOptionsSelect from "../../json/WeightCoreOptions";
import FiveOptionsCoreSelect from "../../json/FiveCoreOptions";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

export default {
  name: "SurveyBuilder",
  data() {
    return {
      questionTypes: QuestionTypesHistoricClinicSelect,
      question: this.options,
      selectedType: null,
      tabBuilder: this.tab,
      fiveOptionsCoreSelect: FiveOptionsCoreSelect,
      weightCoreOptionsSelect: WeightCoreOptionsSelect,
    };
  },
  components: {
    "vue-dropzone": vue2Dropzone,
  },
  props: ["options", "tab"],
  computed: {},
  watch: {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
    this.question.type = this.question.type ? this.question.type : "DEFAULT";
    this.selectedType = this.question.type;
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    resetDefault(sequence) {
      if (this.question) {
        this.question.value = sequence;
      }
    },
    /**
     * @desc {String} type
     * @param {String} type
     * @return {null}
     */
    questionTypeChanged(type) {
      this.question.type = this.selectedType;
      switch (type) {
        case "BOOLEAN":
          this.question.options = [
            {body: "Si", sequence: 1},
            {body: "No", sequence: 2},
          ];
          this.question.value = 1;
          break;
        case "NUMBER":
          this.question.value = this.question.minValue;
          break;
        case "CORE":
          this.question.options = [
            {body: "Nunca", sequence: 1, weight: 0},
            {body: "Casi Nunca", sequence: 2, weight: 1},
            {body: "A veces", sequence: 3, weight: 2},
            {body: "Casi siempre", sequence: 4, weight: 3},
            {body: "Siempre", sequence: 5, weight: 4},
          ];
          this.question.value = 1;
          break;
        default:
      }
    },

    /**
     * @param {null}
     * @return {null}
     */
    addAnotherAnswer() {
      if (!this.question.options) {
        this.question.options = [];
      }
      this.question.uuid = this.getGUID();
      let maxSequence = Number(
          Math.max(...this.question.options.map((x) => x.sequence))
      );
      if (!maxSequence) {
        maxSequence = this.question.options.length;
      }
      this.question.options.push({
        body: null,
        sequence: maxSequence + 1,
        nextQuestion: null,
        imageUrl: null,
      }); // eslint-disable-line
      this.$forceUpdate();
    },

    /**
     * @param {Object, Number}  options, index
     * @return {null}
     */
    deleteQuestionOptionItem(options, index) {
      this.question.options.splice(index, 1);
    },

    /**
     * @param {null}
     * @return {String} guid
     */
    getGUID() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
      }

      return `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4() + s4() + s4()}`;
    },

    /**
     * @param {Object} question
     * @return {null}
     */
    saveQuestion(question) {
      question.uuid = question.uuid ? question.uuid : this.getGUID(); // eslint-disable-line
      question.tab = this.tabBuilder;
      this.$root.$emit("add-update-question", question, question.tab);
      this.question = {type: "DEFAULT"};
    },

    /**
     * @param {Object} question
     * @return {null}
     */
    cancelQuestion(question) {
      window.console.log(question);
      this.question = {type: "DEFAULT"};
    },

    /**
     * @param {Object} question
     * @return {null}
     */
    deleteQuestion(question) {
      //window.console.log(question);
    },

    /**
     * @param {Number} intervals
     * @return {null}
     */
    changeLabelsLength(intervals) {
      this.question.labels.length = intervals;
    },
  },
};
</script>

<style lang="scss" scoped>
$color-primary: #f8f8f8;
$color-secondary: #eaf0f4;
$color-blue: #4c8ce4;
$color-orange: #ff9635;
$color-red: #f06559;
$color-green: #48bf7a;

@for $i from 0 through 5 {
  .p-#{$i * 2} {
    padding: #{$i * 2}px !important;
  }
  .pt-#{$i * 2} {
    padding-top: #{$i * 2}px !important;
  }
  .pr-#{$i * 2} {
    padding-right: #{$i * 2}px !important;
  }
  .pb-#{$i * 2} {
    padding-bottom: #{$i * 2}px !important;
  }
  .pl-#{$i * 2} {
    padding-left: #{$i * 2}px !important;
  }
  .m-#{$i * 2} {
    margin: #{$i * 2}px !important;
  }
  .mt-#{$i * 2} {
    margin-top: #{$i * 2}px !important;
  }
  .mr-#{$i * 2} {
    margin-right: #{$i * 2}px !important;
  }
  .mb-#{$i * 2} {
    margin-bottom: #{$i * 2}px !important;
  }
  .ml-#{$i * 2} {
    margin-left: #{$i * 2}px !important;
  }
  .fs-#{$i * 2} {
    font-size: #{$i * 2}px !important;
  }
}

.color-blue {
  color: $color-blue;
}

.color-orange {
  color: $color-orange;
}

.color-red {
  color: $color-red;
}

.color-green {
  color: $color-green;
}

.vue-survey-builder-content {
  font-family: Arial, Helvetica, sans-serif;
  font-weight: normal;
  border: 1px solid #ddd;
  padding: 10px;
  background-color: $color-primary;
  border-radius: 2px;
  margin: 12px 0;

  margin-top: 16px;

  b-form-input[type="text"],
  b-form-input[type="number"],
  select {
    width: 100%;
    padding: 0 10px;
    height: 38px;
    margin: 8px 0;
    display: inline-block;
    border: 1px solid #ccc;
    border-radius: 2px;
    box-sizing: border-box;
    font-size: 12px;
    background-color: #fff;
  }

  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    background-position: right 50%;
    background-repeat: no-repeat;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAMCAYAAABSgIzaAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBNYWNpbnRvc2giIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDZFNDEwNjlGNzFEMTFFMkJEQ0VDRTM1N0RCMzMyMkIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDZFNDEwNkFGNzFEMTFFMkJEQ0VDRTM1N0RCMzMyMkIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo0NkU0MTA2N0Y3MUQxMUUyQkRDRUNFMzU3REIzMzIyQiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo0NkU0MTA2OEY3MUQxMUUyQkRDRUNFMzU3REIzMzIyQiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PuGsgwQAAAA5SURBVHjaYvz//z8DOYCJgUxAf42MQIzTk0D/M+KzkRGPoQSdykiKJrBGpOhgJFYTWNEIiEeAAAMAzNENEOH+do8AAAAASUVORK5CYII=);
  }

  button {
    padding: 10px;
    text-align: center;
    font-size: 14px;
    margin: 2px 0;
    cursor: pointer;
    border: 1px solid $color-primary;
  }

  .float-left {
    float: left;
  }

  .float-right {
    float: right;
  }

  .text-center {
    text-align: center;
  }

  .text-right {
    text-align: right;
  }

  .width-90 {
    width: 90% !important;
    display: inline-block;
  }

  .width-10 {
    width: 10% !important;
    display: inline-block;
  }

  .display-block {
    display: block;
    clear: both;
  }

  .display-inline-block {
    display: inline-block;
    clear: both;
  }

  .clear-both {
    clear: both;
    margin-top: 24px;
  }

  .vsb-btn-link {
    border: none;
    background: none;
    padding: 5px;
  }

  .question-section {
    border: 1px solid $color-secondary;
    padding: 10px;
    margin: auto;
  }

  .vsb-block {
    display: block;
    padding: 5px 0;
  }

  .vsb-choices-text {
    font-size: 16px;
  }

  .vsb-select {
    max-width: 200px;
  }

  .char-limit-b-form-input {
    max-width: 100px;
  }

  b-form-input:disabled,
  textarea:disabled {
    background: $color-primary;
    pointer-events: none;
    cursor: no-drop;
  }

  .buttons-section {
    padding-top: 20px;
    clear: both;
  }

  *:focus {
    outline: none;
  }

  .scale-type {
    .intervals b-form-input {
      width: 60px;
    }
  }
}
</style>
